module.exports = __webpack_public_path__ + "img/05.050a288b.jpg";